import { CSVLink } from "react-csv";

const DownloadCSVLink = ({name,data,columns}) => {
    const currData = data.map(row => {
      return Object.keys(row).reduce((acc, key) => {
        if (columns.map(col => col.key).includes(key)) {
          acc[key] = row[key];
        }
        return acc;
      }, {});
    });
    return (
      <CSVLink filename={name} data={currData}>
        <i className="icon-excel fs-16 text-success" ></i>
      </CSVLink>)
  }
  export default DownloadCSVLink